import React from 'react';
import styled from 'styled-components';
import { SearchAsYouType } from '../SearchAsYouType';
import { declareWithDefaults } from '../../../helpers/typescript';
import { HeaderMinimalistic } from '../../CategorizedContent/Header';
import { ItemMinimalistic } from '../../CategorizedContent/Item';
import { SearchBoxWithRoundedCorners } from '../../SearchBox';
import { remappedCategorizedContentMinimalisticFactory } from './remappedCategorizedContentMinimalisticFactory';
import { fontFamilies } from '../../../helpers/fonts';

/* Types */
export type SearchAsYouTypeMinimalisticProps = React.ComponentPropsWithoutRef<typeof SearchAsYouType>;

/* Components */
const NoResultsWrapper = styled.span`
  color: black;
  font-family: ${fontFamilies.light};
  font-size: 13px;
`;

const NoResultsComponent: React.FC<{ searchBoxValue: string }> = ({ searchBoxValue }) => {
  return <NoResultsWrapper>{`No results found for "${searchBoxValue}"`}</NoResultsWrapper>;
};

const Component: React.FC<SearchAsYouTypeMinimalisticProps> = props => {
  return <SearchAsYouType {...props} />;
};

const defaultProps = {
  headersWithItemsDisplay: {
    component: remappedCategorizedContentMinimalisticFactory({
      estimatedRowSize: 23,
      headers: { component: HeaderMinimalistic },
      initialListWidth: 190,
      items: { component: ItemMinimalistic },
      maxHeight: 300,
    }),
    forceHideHeaders: false,
    onItemClicked: () => {},
  },
  OnAllAndNonzeroNodesHiddenComponent: NoResultsComponent,
  searchBox: {
    component: SearchBoxWithRoundedCorners,
  },
  shouldHideHeadersOnText: true,
};

export const SearchAsYouTypeMinimalistic = declareWithDefaults<
  SearchAsYouTypeMinimalisticProps,
  keyof typeof defaultProps
>(Component, defaultProps);
